import { QRFC } from "./QRFC";

export class QUploadExcelJSON extends QRFC {
  constructor() {
    super();
    this.fContentValue = "multipart/form-data";
    this.fContentDisp = "Content-Disposition";
    this.fDispType = "form-data";
  }

  InitRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  SetParams(org, user, jsondata) {
    this.AddEncodedParameter("jsondata", jsondata);
    this.AddEncodedParameter("org", org);
    this.AddEncodedParameter("user", user);
  }

  GetCallName() {
    return "quploadexceljson";
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    var success = true;
    if (r == "failure") success = false;

    callBackObj.ExcelJSONResult(success, r);
  }
}
